/**
 * List Component
 * Displays ordered or unordered lists with consistent styling
 */

import { memo } from 'react';
import { designTokens } from '../../constants/designTokens';

interface ListProps {
  items: string[];
  ordered?: boolean;
  compact?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export const List = memo(function List({
  items,
  ordered = false,
  compact = false,
  style,
  className,
}: ListProps) {
  const listStyle: React.CSSProperties = {
    margin: 0,
    padding: `0 0 0 ${designTokens.spacing.lg}`,
    ...style,
  };

  const itemStyle: React.CSSProperties = {
    marginBottom: compact ? designTokens.spacing.xs : designTokens.spacing.sm,
    color: designTokens.colors.text.secondary,
    fontSize: designTokens.typography.fontSize.md,
    lineHeight: designTokens.typography.lineHeight.relaxed,
  };

  const ListTag = ordered ? 'ol' : 'ul';

  return (
    <ListTag style={listStyle} className={className}>
      {items.map((item, index) => (
        <li key={index} style={itemStyle}>
          {item}
        </li>
      ))}
    </ListTag>
  );
});
